module.exports = __webpack_public_path__ + "img/7-July.f100f5d7.jpg";